@if (card.data[0]) {
    @if (card.context.use_new_ui) {
        <app-new-ui-layout [card]="card" [timeline_id]="timeline_id"></app-new-ui-layout>
    } @else if (!card.context.use_new_ui) {
        <app-social-feed-carousel [social_feed]="card.data[0]"></app-social-feed-carousel>
    }
}
